import React, { useState, useEffect, Fragment } from 'react'

import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Checkbox } from '@material-ui/core'

import { updateVisit } from '../../../actions/visits/visits.actions'

import { useDispatch } from 'react-redux'
import { isEqual } from 'lodash'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start'
	},
	checkbox: {
		'&.Mui-disabled.Mui-checked .MuiIconButton-label .MuiSvgIcon-root': {
			fill: '#A2A1A4'
		}
	},
	avatar: {
		background: '#C4C4C4',
		height: '32px',
		width: '32px',
		marginTop: '12px',
		marginBottom: '12px'
	},
	editButton: {
		color: '#6B4AD6',
		fontWeight: '600px',
		fontSize: '16px',
		textTransform: 'capitalize'
	},
	editLabel: {
		fontWeight: '600',
		textTransform: 'none',
		fontSize: '16px'
	}
}))

const EditMedsDialog = (props) => {
	const classes = useStyles()

	let {
		isShown,
		setIsShown,
		visit,
		pet,
		showEditMedPopup,
		setNotAvailableMeds,
		saveAvailableMeds,
		selectedMeds,
		setSelectedMeds,
		initialMeds,
		setInitialMeds
	} = props

	const [skipFirstMeds, setSkipFirstMeds] = useState(false)
	const [areInitialMedsSkipped, setAreInitialMedsSkipped] = useState(false)

	useEffect(() => {
		if (visit && pet && pet.medication) {
			const activeMedications = pet.medication.filter((med) => med.active !== false)
			setInitialMeds(activeMedications.filter((med) => !visit.not_present_meds.includes(med._id)))

			let areMedsSkipped =
				visit.medications &&
				visit.medications.length &&
				visit.medications.filter((m) => m.pet_id === pet._id).some((m) => m.skipped)

			setAreInitialMedsSkipped(areMedsSkipped)
		}
	}, [visit, pet, isShown])

	useEffect(() => {
		if (pet && pet.medication) {
			let notAvailableMeds = pet.medication
				.filter((med) => med.active !== false)
				.filter((med) => !selectedMeds.map((med) => med._id).includes(med._id))
				.map((med) => med._id)

			setNotAvailableMeds(notAvailableMeds)
		}
	}, [selectedMeds, pet])

	useEffect(() => {
		if (initialMeds) {
			setSelectedMeds(initialMeds)
		}
	}, [initialMeds])

	const renderMedSelections = () => {
		const activeMedications = pet?.medication?.filter((med) => med.active !== false) || []

		return activeMedications.length
			? activeMedications.map((med, index) => {
					let checked = selectedMeds.map((med) => med._id).includes(med._id) ? true : false

					return (
						<div
							key={med._id}
							style={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								justifyContent: 'space-between',
								borderBottom: `${index === activeMedications.length - 1 ? 0 : 1}px solid #D5D5D7`,
								padding: '16px'
							}}>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									alignItems: 'center'
								}}>
								<Checkbox
									checked={checked}
									className={classes.checkbox}
									onChange={(e) => {
										if (selectedMeds.map((med) => med._id).includes(med._id)) {
											let updatedSelectedMeds = selectedMeds.filter((m) => m._id !== med._id)
											setSelectedMeds(updatedSelectedMeds)
										} else {
											let updatedSelectedMeds = [...selectedMeds, med]
											setSelectedMeds(updatedSelectedMeds)
										}
									}}
									style={{
										marginLeft: '8px',
										marginRight: '8px'
									}}
								/>
								<div>
									<Typography style={{ marginLeft: '16px', textTransform: 'capitalize' }}>
										{med.name}
									</Typography>
									<Typography
										style={{
											marginLeft: '16px',
											textTransform: 'capitalize',
											fontSize: '14px'
										}}>
										{med.frequency}
									</Typography>
								</div>
							</div>
							<div>
								<Button
									variant="text"
									color="secondary"
									classes={{
										label: classes.editLabel
									}}
									disabled={!checked}
									onClick={(e) => showEditMedPopup(med)}>
									Edit
								</Button>
							</div>
						</div>
					)
			  })
			: (
					<Typography style={{ padding: '16px' }}>
						No medications to make available. Edit medications on the pet profile.
					</Typography>
			  )
	}

	const renderSkipFirstMeds = () => (
		<div
			style={{
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				padding: '16px'
			}}>
			<Checkbox
				checked={skipFirstMeds || areInitialMedsSkipped ? true : false}
				className={classes.checkbox}
				disabled={areInitialMedsSkipped}
				onChange={(e) => setSkipFirstMeds(!skipFirstMeds)}
				style={{
					marginLeft: '8px',
					marginRight: '8px'
				}}
			/>
			<Typography style={{ marginLeft: '16px', textTransform: 'capitalize' }}>
				Skip first timeblock of meds
			</Typography>
		</div>
	)

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => setIsShown(false)}
			PaperProps={{
				style: {
					minWidth: '448px',
					maxWidth: '448px',
					width: '448px'
				}
			}}>
			<DialogTitle
				style={{
					marginBottom: 16
				}}>
				EDIT AVAILABLE MEDS
			</DialogTitle>
			<DialogContent>
				<Typography
					variant="body2"
					style={{
						marginBottom: 24
					}}>
					Select the meds to be available during the appointment.
				</Typography>

				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						marginBottom: 8
					}}>
					<Typography variant="overline"> Meds on Pet Profile</Typography>

					<Button
						onClick={() => {
							let url = `/clients/${visit.household_id}/pets/${pet._id}?showMedication=true`
							window.open(url)
						}}>
						<Typography className={classes.editButton} style={{ fontWeight: '800', fontSize: '14px' }}>
							EDIT ON PROFILE
						</Typography>
						<i className="fas fa-window-restore" style={{ color: '#6B4AD6', marginLeft: '8px' }} />
					</Button>
				</div>

				<div
					style={{
						border: '1px solid #D5D5D7',
						borderRadius: '6px',
						marginBottom: '16px'
					}}>
					{renderMedSelections()}
				</div>

				{visit.type === 'boarding' ? (
					<Fragment>
						<Typography
							variant="overline"
							style={{
								marginBottom: 8
							}}>
							Exceptions
						</Typography>

						<div
							style={{
								border: '1px solid #D5D5D7',
								borderRadius: '6px',
								marginBottom: '16px'
							}}>
							{renderSkipFirstMeds()}
						</div>
					</Fragment>
				) : null}
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button
					variant="contained"
					onClick={() => {
						if (skipFirstMeds || !isEqual(initialMeds.sort(), selectedMeds.sort())) {
							saveAvailableMeds(skipFirstMeds)
						}

						setIsShown(false)
					}}
					color="secondary">
					Done
				</Button>

				<Button
					variant="outlined"
					onClick={() => {
						setIsShown(false)
					}}
					color="secondary">
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default EditMedsDialog
